import Scope from './scope';
export class NodeType {
    constructor(name) {
        this.name = name;
        this._attributes = new Map();
        this._references = new Map();
        this._functions = new Map();
    }
    setAtt(name, type) {
        this._attributes.set(name, type);
    }
    setRef(name, type) {
        this._references.set(name, type);
    }
    setFunc(name, scope) {
        this._functions.set(name, scope);
    }
    getAtt(name) {
        return this._attributes.get(name);
    }
    getRef(name) {
        return this._references.get(name);
    }
    getFunc(name) {
        return this._functions.get(name);
    }
    init(scope) {
        this._attributes.forEach((value, key) => scope.setRef(key, { type: value.type }));
        this._references.forEach((value, key) => scope.setRef(key, { type: 'object', value: new Scope(key) }));
        this._functions.forEach((value, key) => scope.setRef(key, { type: 'function', value: new Scope(key) }));
    }
}
//# sourceMappingURL=node-type.js.map